import { render } from "./player-term-assigment-overlay.vue?vue&type=template&id=f0b67ecc"
import script from "./player-term-assigment-overlay.vue?vue&type=script&lang=js"
export * from "./player-term-assigment-overlay.vue?vue&type=script&lang=js"

import "./player-term-assigment-overlay.vue?vue&type=style&index=0&id=f0b67ecc&lang=scss"
script.render = render

export default script